<template>
	<div class="position-relative">
		<app-loader v-if="!chartInit" style="z-index: 1 !important"/>
		<div id="chartdiv" ref="chartdiv"></div><!-- {{dataChange}} -->
	</div>
</template>
<script>
import * as am4core from "../../../../../node_modules/@amcharts/amcharts4/core"
import * as am4charts from "../../../../../node_modules/@amcharts/amcharts4/charts"
// import am4themes_animated from "../../../../../node_modules/@amcharts/amcharts4/themes/animated"
import am4themes_dark from "../../../../../node_modules/@amcharts/amcharts4/themes/dark"

// am4core.useTheme(am4themes_animated);
am4core.useTheme(am4themes_dark);
am4core.options.autoSetClassName = true;
am4core.options.commercialLicense = true;

import { commonAllmixins } from '@/plugins/commonAll'
export default {
    name: 'Buy-Sell-Depth-chart',
    mixins: [commonAllmixins],
     // props:['buySellType'],
    data() {
        return {
        	chart:{},
        	chart_data:[],
        	chartInit: false

        }
    },
    props:['bid','asks','size'],
    watch:{
    	// asks(val){
    	// 	this.dataChange()
    	// }
    	appTheme(val){
            this.InitializeChart()
        },
    },
    methods:{
    	processData(list, type, desc) {
    		var res =[];
		    // Convert to data points
		    for(var i = 0; i < list.length; i++) {
			    list[i] = {
			        value: Number(list[i][0]),
			        volume: Number(list[i][1])/Number(this.size),
			    }
		    }
		    // Sort list just in case
		    /*list.sort(function(a, b) {
		        if (a.value > b.value) {
			        return 1;
			    }
			    else if (a.value < b.value) {
			        return -1;
			    }
			    else {
			        return 0;
			    }
		    });*/
		    // Calculate cummulative volume
		    if (desc) {
			    for(var i = list.length - 1; i >= 0; i--) {
			        if (i < (list.length - 1)) {
			        	list[i].totalvolume = list[i+1].totalvolume + list[i].volume;
			        }
			        else {
			        	list[i].totalvolume = list[i].volume;
			        }
			        var dp = {};
			        dp["value"] = list[i].value;
			        dp[type + "volume"] = list[i].volume;
			        dp[type + "totalvolume"] = list[i].totalvolume;
			        res.unshift(dp);
			    }
		    }
		    else {
			    for(var i = 0; i < list.length; i++) {
			        if (i > 0) {
			            list[i].totalvolume = list[i-1].totalvolume + list[i].volume;
			        }
			        else {
			            list[i].totalvolume = list[i].volume;
			        }
			        var dp = {};
			        dp["value"] = list[i].value;
			        dp[type + "volume"] = list[i].volume;
			        dp[type + "totalvolume"] = list[i].totalvolume;
			        res.push(dp);
			    }
		    }
		    return res
		},
		InitializeChart(){
			const _that = this
			// am4core.ready(function() {
			// 	try{
					var chart = am4core.create(_that.$refs.chartdiv, am4charts.XYChart);
					chart.numberFormatter.numberFormat = "#,###.####";

					// Create axes
					var xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
					xAxis.dataFields.category = "value";
					//xAxis.renderer.grid.template.location = 0;
					xAxis.renderer.minGridDistance = 50;
					// xAxis.title.text = "Price (BTC/ETH)";
					xAxis.element.node.attributeStyleMap
					xAxis.fontSize = 10;
					var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
					yAxis.fontSize = 7;
					yAxis.renderer.opposite = true;
					yAxis.renderer.inside = true;
					let textCOlor = '', gridColor = '';
					if(this.appTheme){
		                textCOlor = '#dee2e6'
		                gridColor = '#53659f'
		            }else{
		                textCOlor = '#0f121d'
		                gridColor = '#BABCC4'
		            }
					xAxis.renderer.grid.template.stroke = gridColor;
					xAxis.renderer.labels.template.fill = textCOlor;
					yAxis.renderer.grid.template.stroke = gridColor;
					yAxis.renderer.labels.template.fill = textCOlor;
					// yAxis.title.text = "Volume";

					// Create series
					var series = chart.series.push(new am4charts.StepLineSeries());
					series.dataFields.categoryX = "value";
					series.dataFields.valueY = "bidstotalvolume";
					series.strokeWidth = 2;
					series.stroke = am4core.color("#10BD72");
					series.fill = series.stroke;
					series.fillOpacity = 0.1;
					series.tooltipText = "BID: [bold]{categoryX}[/]\nTotal volume: [bold]{valueY}[/]\nVolume: [bold]{bidsvolume}[/]"

					var series2 = chart.series.push(new am4charts.StepLineSeries());
					series2.dataFields.categoryX = "value";
					series2.dataFields.valueY = "askstotalvolume";
					series2.strokeWidth = 2;
					series2.stroke = am4core.color("#F25767");
					series2.fill = series2.stroke;
					series2.fillOpacity = 0.1;
					series2.tooltipText = "Ask: [bold]{categoryX}[/]\nTotal volume: [bold]{valueY}[/]\nVolume: [bold]{asksvolume}[/]"

					var series3 = chart.series.push(new am4charts.ColumnSeries());
					series3.dataFields.categoryX = "value";
					series3.dataFields.valueY = "bidsvolume";
					series3.strokeWidth = 0;
					series3.fill = am4core.color('#10BD72');
					series3.fillOpacity = 0.2;

					var series4 = chart.series.push(new am4charts.ColumnSeries());
					series4.dataFields.categoryX = "value";
					series4.dataFields.valueY = "asksvolume";
					series4.strokeWidth = 0;
					series4.fill = am4core.color("#F25767");
					series4.fillOpacity = 0.2;
					// Add cursor
					chart.cursor = new am4charts.XYCursor();
					_that.chart = chart
					_that.chartInit = true
					chart.data = _that.chart_data
			// 	}catch(e){console.log(e)}
			// 	// this.chart = chart;
			// }); // end am4core.ready()
		},
		dataChange(){
			if(this.bid.length && this.asks.length){
				var bid = this.processData(this.bid, "bids", true);
				var res = [];
				/*bid.push({
				  value: "0"
				})*/
	  			var asks = this.processData(this.asks, "asks", false);
	  			var totalData = bid.concat(asks)
	  			// console.log('data-------->',totalData)
	  			// console.log('data-------->',JSON.stringify(totalData))
	  			if(totalData.length > 0 && totalData[0].value){
	  				this.chart_data = totalData
	  				if(this.chartInit){
	  					this.chart.data = this.chart_data
	  				}else{
	  					this.InitializeChart()
	  				}
	  			}
			}

  			// console.log("totalData==============>", totalData)
		}
    },
    /*mounted(){
    	$(document).ready(function(){
			$("g[aria-labelledby]").hide();
		})
    },*/
    beforeDestroy() {
	    if (this.chart) {
	      	try{
	      		this.chart.dispose();
	      	}catch(e){}
	    }
	},
	created(){
		const _that = this
		var myVar = setInterval(()=>{
			if(_that.bid.length >0){
				_that.dataChange()
				// console.log('clearInterval')
				clearInterval(myVar)
			}
		}, 1000);
		// _that.InitializeChart()
		setTimeout(function(){ _that.InitializeChart() }, 1000);
	}
   
	
}
</script>



// WEBPACK FOOTER //
// src/components/website/user/home-elements/depth-chart.vue